<template>
    <notifications
        at-global-notifications
        group="global"
        class="a-global-notifications global-notifications"
        position="top center"
        width="100%"
    />
</template>

<script>

import EventBus from './../../../utils/event-bus'
import { SHOW_NOTIFICATION } from './../../../utils/constants/event-constants'

export default {
    name: 'AGlobalNotifications',
    methods: {
        initEventListeners() {
            EventBus.$on(SHOW_NOTIFICATION, this.showNotification)
        },
        deactivateEventListeners() {
            EventBus.$off(SHOW_NOTIFICATION, this.showNotification)
        },
        showNotification(data, group = 'global') {
            const notification = Object.assign({}, data, { group });
            this.$notify(notification);
        }
    },
    mounted() {
        this.initEventListeners();
    },
    beforeDestroy() {
        this.deactivateEventListeners();
    }
};
</script>

<style lang="scss">
    @import 'theme';
</style>
